import React from 'react'
import { SprintPacketHydrated } from '@marketing-milk/interfaces'
import { SurfacePalette } from '../../tokens'
import { SectionCard } from './SectionCard'
import { MarketingMilkHandoffCard } from './MarketingMilkHandoffCard'
import { BudgetRecommendationBlock } from './BudgetRecommendationBlock'

interface Props {
  palette: SurfacePalette
  packet: SprintPacketHydrated
}

export const PerformanceReviewSection = ({ palette, packet }: Props) => {
  return (
    <SectionCard
      palette={palette}
      sectionKey="performance-review"
      title="Performance Review"
      commentAnchor={{
        type: 'section',
        id: `${packet.id}:performance-review`,
        label: 'Performance Review',
      }}
    >
      <MarketingMilkHandoffCard palette={palette} packet={packet} />
      <BudgetRecommendationBlock
        palette={palette}
        packetID={packet.id}
        narrative={packet.narrative ?? []}
      />
    </SectionCard>
  )
}
